import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { type DniAnalysisTransformer } from './transformers'

export const purchaseTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'purchase') return event
  const { meta, ...eventParamsWithoutMeta } = event.eventParams
  const { currency = 'TWD', value = 0, items, transaction_id, tax } = eventParamsWithoutMeta
  const { purchase_email, purchase_phone, user_type, country_code } = meta || {}
  if (!items) return {
    ...event,
    eventParams: eventParamsWithoutMeta,
  }
  const campaignCode = 'campaign_code' in event.eventParams ? event.eventParams.campaign_code : undefined
  if (platform === AnalyticsPlatforms.META_PIXEL) {
    return {
      eventName: 'Purchase',
      eventParams: {
        content_ids: items.map(item => item.item_id).filter((id): id is string => id !== undefined),
        content_type: 'product',
        contents: items.map(item => ({
          id: item.item_id || 'None',
          quantity: item.quantity || 0,
        })),
        num_items: items.length,
        currency,
        value,
        campaign_code: campaignCode,
      },
      eventId: transaction_id,
    }
  }
  if (platform === AnalyticsPlatforms.OMNICHAT) {
    const products = items.map(item => ({
      id: item.item_id || '',
      quantity: item.quantity || 0,
      price: String(item.price || 0),
      brand: item.item_brand || '',
      name: item.item_name || '',
      variant: item.item_variant || '',
    }))
    return {
      eventName: 'purchase',
      eventParams: {
        items: products,
        transaction_id,
        currency,
        amount: String(value),
      },
    }
  }
  if (platform === AnalyticsPlatforms.KLAVIYO) {
    if (!transaction_id) return null
    return {
      eventName: 'purchase',
      eventParams: {
        $event_id: transaction_id,
        content_ids: items.map(item => item.item_id).filter((id): id is string => id !== undefined),
        items: items.map(item => ({
          item_name: item.item_name || undefined,
          quantity: item.quantity || undefined,
          item_id: item.item_id || undefined,
          product_id: item.item_variant || undefined,
          price: item.price || undefined,
        })),
        tax: Number(tax) || undefined,
        transaction_id,
        $value_currency: currency,
        $value: value,
        purchase_email,
        purchase_phone,
        user_type,
        country_code,
      },
    }
  }

  return {
    ...event,
    eventParams: eventParamsWithoutMeta,
  }
}
